class SearchOverlay {
  constructor({ searchOverlayToggle }) {
    this.searchOverlayToggle = searchOverlayToggle;
    this.searchOverlay = document.querySelector('#search-overlay');
    this.searchCloseButton = document.querySelector('#search-close');
    this.searchButton = document.querySelector('#search-overlay-button');
    this.form = this.searchOverlay.querySelector('.search-overlay__form');
  }

  init() {
    this.searchOverlayToggle.addEventListener('click', (e) => {
      e.preventDefault();
      this.searchOverlay.classList.add('js-open');

      this.searchCloseButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.searchOverlay.classList.remove('js-open');
      });

      console.log('search overlay init');

      document.getElementById('search-close').focus();

      this.searchButton.addEventListener('keydown', function(e){
        if((e.which === 9 && !e.shiftKey)) {
          e.preventDefault();
          document.getElementById('search-close').focus();
        }
      });

      this.searchCloseButton.addEventListener('keydown', function(e){
        if((e.which === 9 && e.shiftKey)) {
          e.preventDefault();
          document.getElementById('search-overlay-button').focus();
        }
      });

      document.addEventListener('click', (e) => {
        if (e.target.classList.contains('search-overlay')) {
          this.searchOverlay.classList.remove('js-open');
        }
      });

      this.form.addEventListener('submit', (e) => {
        e.preventDefault();

        const searchTerm = e.target.elements[0].value;

        window.location.href = `/site-search?q=${encodeURI(searchTerm)}`;
      });
    });
  }
}

export default SearchOverlay;
